import { jsx as a } from "react/jsx-runtime";
import { useTranslation as N } from "react-i18next";
import { Dialog as p } from "../../../../../components/elements/dialog/dialog.js";
import i from "./station-dialog.module.less.js";
import { Station as c } from "../station/station.js";
const T = ({
  station: o,
  isOpen: r,
  trailerRentalPageUrl: e,
  geolocation: n,
  trackingFunctions: s,
  onClose: t,
  trailerRentalStationUrlResolveFunction: m
}) => {
  const { t: l } = N();
  return /* @__PURE__ */ a(
    p,
    {
      title: o.stationName,
      ariaDescription: l("FIND_STATION_STATION_MODAL_ARIA_DESCRIPTION", { stationName: o.stationName }),
      isOpen: r,
      isModal: !1,
      onClose: t,
      onEscapeKeyDown: t,
      anchor: "right",
      dialogClassName: i.dialog,
      contentClassName: i.dialogContent,
      children: /* @__PURE__ */ a(
        c,
        {
          trailerRentalStationUrlResolveFunction: m,
          station: o,
          trailerRentalPageUrl: e,
          geolocation: n,
          trackingFunctions: s
        }
      )
    }
  );
};
export {
  T as default
};
